var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { ContainerLayout } from "../../components/ContainerLayout";
import { FixedMenu } from "../../components/FixedMenu";
import { Loading } from "../../components/Loading";
import { NaoEncontrado } from "../../components/NaoEncontrado";
import { SnackbarFeedback } from "../../components/SnackbarFeedback";
import { CardIpva } from "../../components/Veiculos/CardIpva";
import { InfoVeiculo } from "../../components/Veiculos/InfoVeiculo";
import { obterListaIpva } from "../../services/veiculos.service";
export var ConsultaIpva = function () {
    var placa = useParams().placa;
    var _a = useState(), debitos = _a[0], setDebitos = _a[1];
    var _b = useState(false), erro = _b[0], setErro = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(false), consultaVazia = _d[0], setConsultaVazia = _d[1];
    useEffect(function () {
        var fetchDebitos = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        if (!placa) return [3 /*break*/, 2];
                        payload = {
                            placa: placa,
                        };
                        return [4 /*yield*/, obterListaIpva(payload)];
                    case 1:
                        response = _a.sent();
                        setDebitos(response);
                        _a.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        if (error_1.response &&
                            error_1.response.data.MensagemRetorno ===
                                "SEFAZ: Veículo não possui débitos") {
                            setConsultaVazia(true);
                        }
                        else {
                            setErro(true);
                        }
                        console.error(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchDebitos();
    }, [placa]);
    if (loading) {
        return _jsx(Loading, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(FixedMenu, { title: "D\u00E9bitos IPVA", goBackTo: "/veiculos/consulta-ipva" }), !consultaVazia ? (debitos && (_jsx(Box, __assign({ mt: { xs: "17rem", md: "13rem" } }, { children: _jsxs(ContainerLayout, { children: [_jsx(InfoVeiculo, {}), _jsx(Typography, __assign({ variant: "h5", fontSize: "1.375rem", fontWeight: "500", mb: "1rem" }, { children: "D\u00E9bitos em Aberto" })), _jsx(Divider, { sx: { mb: "1rem" } }), debitos === null || debitos === void 0 ? void 0 : debitos.map(function (debito) { return (_jsx(CardIpva, { ipva: debito }, debito.numeroControle)); })] }) })))) : (_jsx(ContainerLayout, { children: _jsx(Stack, __assign({ mt: "24rem" }, { children: _jsx(NaoEncontrado, { subtitulo: "O sistema n\u00E3o localizou nenhum d\u00E9bito de IPVA relacionado a placa do ve\u00EDculo selecionado." }) })) })), erro && (_jsx(SnackbarFeedback, { isOpen: erro, message: "Erro ao buscar d\u00E9bitos", type: "error" })), loading && _jsx(Loading, {})] }));
};
